import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo, useState } from "react";
import { Box, Group, Menu, Text, UnstyledButton } from "@mantine/core";
import BoxContainer from "./BoxContainer";
import { Check, ChevronDown } from "./assets/icons.generated";
import { WEIGHT_BOLD } from "./theme/typography";
export default function CustomSelectMenu({ value, data, onChange, miw = 210, }) {
    const [isOpen, setIsOpen] = useState(false);
    const constructedOptions = useMemo(() => {
        return data.map((item) => {
            var _a;
            return (_jsx(Menu.Item, { h: 40, p: "0 6px 0 12px", miw: miw, onClick: () => onChange(item.value), children: _jsxs(Group, { position: "apart", spacing: 10, children: [_jsxs(Group, { spacing: 10, children: [item.icon, _jsx(Text, { size: "sm", fw: WEIGHT_BOLD, children: (_a = item.label) !== null && _a !== void 0 ? _a : item.value })] }), item.value === value && _jsx(Check, {})] }) }, item.value));
        });
    }, [data, value, onChange, miw]);
    const constructedSelectedOption = useMemo(() => {
        var _a, _b;
        const found = (_a = data.find((o) => o.value === value)) !== null && _a !== void 0 ? _a : {
            value: "",
            icon: _jsx(_Fragment, {}),
            label: "Select one",
        };
        return (_jsx(UnstyledButton, { children: _jsx(BoxContainer, { h: 48, p: 0, children: _jsxs(Group, { position: "apart", spacing: 16, px: 16, miw: miw, children: [_jsxs(Group, { spacing: 10, h: 46, children: [found.icon, _jsx(Text, { size: "sm", children: (_b = found.label) !== null && _b !== void 0 ? _b : found.value })] }), isOpen ? (_jsx(ChevronDown, { style: { transform: "rotate(180deg)" } })) : (_jsx(ChevronDown, {}))] }) }) }));
    }, [data, value, miw, isOpen]);
    return (_jsx(Box, { children: _jsxs(Menu, { position: "bottom-end", onChange: setIsOpen, children: [_jsx(Menu.Target, { children: constructedSelectedOption }), _jsx(Menu.Dropdown, { children: _jsx(_Fragment, { children: constructedOptions }) })] }) }));
}
